if (typeof i18n == "undefined"){
  var i18n = {};
}

i18n.previousMonth = 'Mois précédent';
i18n.nextMonth     = 'Mois suivant';
i18n.months        = ['Janvier','Février','Mars','Avril','Mai','Juin','Juillet','Août','Septembre','Octobre','Novembre','Décembre'];
i18n.weekdays      = ['Dimanche','Lundi','Mardi','Mercredi','Jeudi','Vendredi','Samedi'];
i18n.weekdaysShort = ['Dim','Lun','Mar','Mer','Jeu','Ven','Sam'];
